module.exports = __webpack_public_path__ + "media/CN_002.79db21d3.mp3";